var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.788,
    height: 15.788,
    viewBox: "0 0 15.788 15.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.291,
    y1: -0.136,
    x2: 0.903,
    y2: 0.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.267,
    x2: 1,
    y2: 0.733,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "store",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M3,9H15.918v8.612a1.435,1.435,0,0,1-1.435,1.435H4.435A1.435,1.435,0,0,1,3,17.612Z",
    transform: "translate(-0.565 -2.259)",
    fill: "#c6ccd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M10.023,14h4.306v6.459H10.023ZM5,14H8.588v3.588H5Z",
    transform: "translate(-1.129 -3.671)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M7,14h.718v3.588H7Z",
    transform: "translate(-1.694 -3.671)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M5,16H8.588v.718H5Z",
    transform: "translate(-1.129 -4.235)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M10.119,4H12.7l.255,3.588H9.8Z",
    transform: "translate(-2.485 -0.847)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M13.844,4h2.584l.83,3.588H14.1Z",
    transform: "translate(-3.627 -0.847)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M12.8,4h2.552l1.435,3.588H13.63ZM2.435,4H5.05L4.158,7.588H1Z",
    transform: "translate(0 -0.847)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M6.293,4H8.876L8.558,7.588H5.4ZM5.4,7.588V8.665A1.512,1.512,0,0,0,6.979,10.1,1.512,1.512,0,0,0,8.558,8.665V7.588Z",
    transform: "translate(-1.242 -0.847)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1,9v.718a1.512,1.512,0,0,0,1.579,1.435A1.512,1.512,0,0,0,4.158,9.718V9ZM7.315,9v1.435a1.512,1.512,0,0,0,1.579,1.435,1.512,1.512,0,0,0,1.579-1.435V9Z",
    transform: "translate(0 -2.259)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M14.2,9v1.076a1.586,1.586,0,0,0,3.158,0V9H14.2Z",
    transform: "translate(-3.727 -2.259)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M18.6,9v.718a1.586,1.586,0,0,0,3.158,0V9H18.6Z",
    transform: "translate(-4.97 -2.259)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1,9v.718a1.512,1.512,0,0,0,1.579,1.435A1.512,1.512,0,0,0,4.158,9.718v.359a1.512,1.512,0,0,0,1.579,1.435,1.512,1.512,0,0,0,1.579-1.435v.359a1.512,1.512,0,0,0,1.579,1.435,1.512,1.512,0,0,0,1.579-1.435v-.359a1.512,1.512,0,0,0,1.579,1.435,1.512,1.512,0,0,0,1.579-1.435V9.718a1.586,1.586,0,0,0,3.158,0V9Z",
    transform: "translate(0 -2.259)",
    fill: "#010101",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M15.918,3.153H3V2.435A1.435,1.435,0,0,1,4.435,1H14.482a1.435,1.435,0,0,1,1.435,1.435Z",
    transform: "translate(-0.565)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M15.353,3.153H2.435V2.435A1.435,1.435,0,0,1,3.871,1H13.918a1.435,1.435,0,0,1,1.435,1.435ZM8.894,9.432A1.512,1.512,0,0,1,7.315,8v.179A1.512,1.512,0,0,0,8.894,9.612a1.512,1.512,0,0,0,1.579-1.435V8A1.512,1.512,0,0,1,8.894,9.432ZM4.158,7.279A1.512,1.512,0,0,1,2.579,8.715,1.512,1.512,0,0,1,1,7.279v.179A1.512,1.512,0,0,0,2.579,8.894,1.512,1.512,0,0,0,4.158,7.459Zm3.158.359A1.512,1.512,0,0,1,5.736,9.073,1.512,1.512,0,0,1,4.158,7.638v.179A1.512,1.512,0,0,0,5.736,9.253,1.512,1.512,0,0,0,7.315,7.818Zm7.894,1.076A1.512,1.512,0,0,1,13.63,7.279v.179a1.586,1.586,0,0,0,3.158,0V7.279A1.512,1.512,0,0,1,15.209,8.715Zm-3.158.359a1.512,1.512,0,0,1-1.579-1.435v.179a1.512,1.512,0,0,0,1.579,1.435A1.512,1.512,0,0,0,13.63,7.818V7.638A1.512,1.512,0,0,1,12.052,9.073Z",
    fill: "#010101",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M14.482,22.185H4.435A1.435,1.435,0,0,1,3,20.75v.179a1.435,1.435,0,0,0,1.435,1.435H14.482a1.435,1.435,0,0,0,1.435-1.435V20.75A1.435,1.435,0,0,1,14.482,22.185Z",
    transform: "translate(-0.565 -5.577)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.383,
    cy: 0.383,
    r: 0.383,
    transform: "translate(11.724 13.256)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1,9v.718",
    transform: "translate(0 -2.259)",
    fill: "#e83829"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M15.774,11.435A1.512,1.512,0,0,1,14.2,10v.359a1.512,1.512,0,0,1-1.579,1.435,1.512,1.512,0,0,1-1.579-1.435v.359a1.512,1.512,0,0,1-1.579,1.435A1.512,1.512,0,0,1,7.88,10.718v-.359A1.512,1.512,0,0,1,6.3,11.794a1.512,1.512,0,0,1-1.579-1.435V10a1.512,1.512,0,0,1-1.579,1.435q-.072,0-.144-.006l7.894,7.9h3.588a1.435,1.435,0,0,0,1.435-1.435V11.422C15.869,11.426,15.824,11.435,15.774,11.435Z",
    transform: "translate(-0.565 -2.541)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M15.353,3.153V2.435A1.435,1.435,0,0,0,13.918,1H3.871A1.435,1.435,0,0,0,2.435,2.435v.718L1,6.741v.718A1.493,1.493,0,0,0,2.435,8.881v6.472a1.435,1.435,0,0,0,1.435,1.435H13.918a1.435,1.435,0,0,0,1.435-1.435V8.881a1.493,1.493,0,0,0,1.435-1.422V6.741Z",
    fill: "url(#linear-gradient-2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.eecc62a711522ec0fad3b168f9d71214.svg";
export { ForwardRef as ReactComponent };